module.exports = __webpack_public_path__ + "img/cityGenerationGif2.b6c3b358.gif";